export default "__VITE_ASSET__BPT3lapL__"